import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";

import { formatCurrency, formatDateTime } from "../../utilities/helpers";
import moment from "moment";

export default function GroupPurchaseTable({
  data,
  page,
  pageSize,
  setPage,
  setPageSize,
  count,
}) {
  const getTicketDetails = (details) => {
    let seats = details?.selectedSeats;
    let seatKey = Object.keys(seats)[0];
    return Object.values(details.selectedSeats[seatKey])[0]?.length;
  };

  const getTicketScanned = (tickets) => {
    let scanned = tickets.filter((ticket) => ticket.scanned === true);
    return scanned?.length;
  };

  let items = [];

  for (let number = 1; number <= parseInt(count / pageSize); number++) {
    items.push(
      <Pagination.Item
        key={number}
        onClick={() => setPage(number)}
        active={number === page}
      >
        {number}
      </Pagination.Item>,
    );
  }

  return (
    <>
      <Table striped bordered hover className="mt-3" size="sm">
        <thead>
          <tr>
            <th>Email</th>
            <th>Event</th>
            <th>Status</th>
            <th>Complimentary</th>
            <th>Total Tickets</th>
            <th>Tickets Scanned</th>
            <th>Amount Paid</th>
            <th>Date Purchased</th>
          </tr>
        </thead>
        <tbody>
          {data.map((d, index) => (
            <tr key={index}>
              <td>{d?.primary_contact_email}</td>
              <td>{d?.event[0]?.name}</td>
              <td>{d?.status}</td>
              <td>{d?.complimentary ? "Yes" : "No"}</td>
              <td>{getTicketDetails(d?.details)}</td>
              <td>{getTicketScanned(d?.tickets)}</td>
              <td>{formatCurrency(d?.total_due)}</td>
              <td>{formatDateTime(moment(d?.created_at), "default")}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination className="mt-2">{items}</Pagination>
    </>
  );
}
